import React from 'react';
import styled from 'styled-components';
import { Apple as AppleIcon } from '@zocdoc-frontend-common/assets-icons';
import BaseSocialLoginButtonTransparent from './BaseSocialLoginButtonTransparent';

export default function AppleLoginButtonTransparent({
    message = 'Continue with Apple',
    ...props
}) {
    return <StyledLoginButton icon={AppleIcon} message={message} {...props} />;
}

const StyledLoginButton = styled(BaseSocialLoginButtonTransparent)`
    svg {
        fill: #000;
        margin-left: 8px;
    }

    &:hover,
    &:active {
        svg {
            fill: #fff;
        }
    }
`;
